var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.quit),expression:"quit"}],staticClass:"shade"},[_c('div',{staticClass:"shadeBox"},[_c('div',{attrs:{"id":"brokenline"}}),_vm._v(" "),_c('div',{staticClass:"image",on:{"click":function($event){return _vm.closeMark()}}},[_c('img',{attrs:{"src":require("@/assets/img/12.png"),"alt":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b491adf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/balance.vue
// module id = null
// module chunks = 